import { render, staticRenderFns } from "./RelatorioPedidosTarefasForm.vue?vue&type=template&id=494e4b50&scoped=true"
import script from "./RelatorioPedidosTarefasForm.vue?vue&type=script&lang=js"
export * from "./RelatorioPedidosTarefasForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494e4b50",
  null
  
)

export default component.exports